import React, { useEffect } from 'react'
import SEO from '../../../utils/CommonFunctionality/SEO'
import Layout from '../Layout'

export default function faq(props) {
    useEffect(() => {
        const searchInput = document.getElementById('faq-search')
        const clearSearchBtn = document.getElementById('clear-search')
        const noResultsMessage = document.getElementById('no-results')
        const faqSections = document.querySelectorAll('.faq-section')
        const faqItems = document.querySelectorAll('.faq-item')
        const navLinks = document.querySelectorAll('.faq-nav-link')
        const navList = document.getElementById('faq-nav-list')
        const scrollLeftIndicator = document.getElementById('scroll-left')
        const scrollRightIndicator = document.getElementById('scroll-right')

        // Function: Highlight nav on scroll
        function highlightNavOnScroll() {
            const scrollPosition = window.pageYOffset
            let currentSection = null

            faqSections.forEach((section) => {
                const sectionTop = section.offsetTop - 200
                const sectionBottom = sectionTop + section.offsetHeight

                if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                    currentSection = section
                }
            })

            if (currentSection) {
                const currentId = currentSection.getAttribute('id')
                navLinks.forEach((link) => {
                    link.classList.remove('active')
                    if (link.getAttribute('href') === `#${currentId}`) {
                        link.classList.add('active')
                    }
                })
            }
        }

        // Function: Check scroll indicators
        function checkScrollIndicators() {
            if (navList.scrollWidth > navList.clientWidth) {
                scrollLeftIndicator.style.display = navList.scrollLeft > 0 ? 'block' : 'none'
                scrollRightIndicator.style.display =
                    navList.scrollLeft < navList.scrollWidth - navList.clientWidth
                        ? 'block'
                        : 'none'
            } else {
                scrollLeftIndicator.style.display = 'none'
                scrollRightIndicator.style.display = 'none'
            }
        }

        // Navigation click events
        navLinks.forEach((link) => {
            link.addEventListener('click', handleNavClick)
        })

        function handleNavClick(e) {
            e.preventDefault()
            navLinks.forEach((navLink) => navLink.classList.remove('active'))
            this.classList.add('active')

            const targetId = this.getAttribute('href')
            const targetSection = document.querySelector(targetId)
            const navHeight = document.querySelector('.faq-nav')?.offsetHeight || 0

            window.scrollTo({
                top: targetSection.offsetTop - navHeight - 20,
                behavior: 'smooth',
            })
        }

        // Event listeners
        window.addEventListener('scroll', highlightNavOnScroll)
        window.addEventListener('resize', highlightNavOnScroll)
        navList.addEventListener('scroll', checkScrollIndicators)
        window.addEventListener('resize', checkScrollIndicators)

        // Initial calls
        checkScrollIndicators()
        highlightNavOnScroll()

        // Cleanup
        return () => {
            navLinks.forEach((link) => {
                link.removeEventListener('click', handleNavClick)
            })
            window.removeEventListener('scroll', highlightNavOnScroll)
            window.removeEventListener('resize', highlightNavOnScroll)
            navList.removeEventListener('scroll', checkScrollIndicators)
            window.removeEventListener('resize', checkScrollIndicators)
        }
    }, [])

    return (
        <Layout props={props}>
            <SEO title={`${global?.storeDetails?.name} | Frequently asked questions`} />

            <div className="px-md-5 px-3 py-4 staticPgWrapper">
                {/* <h2>FAQs</h2> */}
                <span
                    dangerouslySetInnerHTML={{
                        __html: global.storeDetails.terms,
                    }}
                ></span>
            </div>
        </Layout>
    )
}
